const getDefaultState = () => {
    return {
        companyAdmins: [],
        currentAdminCompany: null,
    }
}

const state = getDefaultState()

const getters = {
    adminCompanies(state: any) {
        return state.companyAdmins.map((admin) => admin.company.data)
    },

    isCompanyAdmin(state: any) {
        return state.companyAdmins.length > 0
    },

    companyAdmins(state: any) {
        return state.companyAdmins
    },

    currentAdminCompany(state: any): string | null {
        return state.currentAdminCompany
    },
}

const mutations = {
    companyAdmins(state: any, payload: any) {
        state.companyAdmins = payload
    },

    currentAdminCompany(state: any, payload: string | null) {
        state.currentAdminCompany = payload
    },

    //RESET
    resetCompanyAdmins(state: any) {
        const initial: any = getDefaultState()
        Object.keys(initial).forEach((key) => {
            state[key] = initial[key]
        })
    },
}

export default {
    state,
    getters,
    mutations,
}
